// extracted by mini-css-extract-plugin
module.exports = {"container":"MostRecent_container__MdksW","title":"MostRecent_title__0SmXj","slide":"MostRecent_slide__9BETA","cardList":"MostRecent_cardList__MVd6s"};